import { useEffect, useState } from 'react';
import { PATH } from 'routes/routeConfig';
import { useNavigate } from 'react-router-dom';
import { useLatestContractStatus } from 'hooks/useLatestContractStatus';

export const useContractUpdateDialog = () => {
  const navigate = useNavigate();
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const { isSigned, isLoading } = useLatestContractStatus();

  const handleClickDialog = () => {
    setIsOpenDialog(false);
    navigate(PATH.ACCOUNT_CONTRACT_UPDATE);
  };
  const handleCloseDialog = () => {
    setIsOpenDialog(false);
  };

  useEffect(() => {
    // 合約狀態還沒回來時 isSigned 會是 false，這時開窗等於對已簽約的老師先跳一次再自己關掉
    if (isLoading) return;
    setIsOpenDialog(!isSigned);
  }, [isSigned, isLoading]);

  return { isOpenDialog, handleClickDialog, handleCloseDialog };
};
